import {
  InternalLinkingMenuLink,
  InternalLinkingMenuContentProps,
} from '@care/navigation/dist/components/types';
import {
  seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection as SEONavigationLinkSection,
  seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection_childCareLinks as SEONavigationLink,
} from '@/__generated__/seoNavigationLinkSection';

const mapToInternalLinkingMenuLink = (linklist: SEONavigationLink[]): InternalLinkingMenuLink[] => {
  return linklist.map((link: SEONavigationLink): InternalLinkingMenuLink => {
    return {
      label: link.title,
      href: link.urlPath,
    };
  });
};

export const mapNavigationMenuContent = (
  seoNavigationLinkSection: SEONavigationLinkSection | undefined
): InternalLinkingMenuContentProps | undefined => {
  if (!seoNavigationLinkSection) return undefined;

  const navigationLinkSectionDefault: InternalLinkingMenuContentProps = {
    childCareLinks: [],
    seniorCareLinks: [],
    petCareLinks: [],
    housekeepingLinks: [],
    tutoringLinks: [],
    jobsLinks: [],
  };

  type InternalLinkingMenuPropKeys = keyof InternalLinkingMenuContentProps;
  const mapToSeoNavigationLinkSectionFields: {
    [key: string]: InternalLinkingMenuPropKeys;
  } = Object.freeze({
    childCareLinks: 'childCareLinks',
    seniorCareLinks: 'seniorCareLinks',
    petCareLinks: 'petCareLinks',
    housekeepingLinks: 'housekeepingLinks',
    tutoringLinks: 'tutoringLinks',
    jobsLinks: 'jobsLinks',
  });

  return Object.entries(seoNavigationLinkSection).reduce(
    (
      currentNavigationLinkSection: InternalLinkingMenuContentProps,
      entry: [string, SEONavigationLink[]]
    ) => {
      const [key, value] = entry;

      if (key === '__typename') {
        return currentNavigationLinkSection;
      }

      const field = mapToSeoNavigationLinkSectionFields[key];
      const navigationLinkSectionCopy = { ...currentNavigationLinkSection };
      const navigationLinkList = mapToInternalLinkingMenuLink(value);

      if (navigationLinkList.length > 0) {
        const allCategoriesLink = {
          label: key === 'jobsLinks' ? 'See all job categories' : 'See all categories',
          href: key === 'jobsLinks' ? '/care-directory#jobs' : '/care-directory#care',
          bold: true,
        };
        navigationLinkList.push(allCategoriesLink);
      }

      navigationLinkSectionCopy[field] = navigationLinkList;

      return navigationLinkSectionCopy;
    },
    navigationLinkSectionDefault
  );
};
